import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics, logEvent as _logEvent, isSupported } from "firebase/analytics";

const firebaseConfig = {
  apiKey:            process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain:        process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId:         process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket:     process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId:             process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId:     process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);

// Analytics — инициализируем только если браузер поддерживает
// (не работает в старых браузерах и при блокировщиках рекламы)
let analytics = null;
isSupported().then(yes => {
  if (yes) analytics = getAnalytics(app);
});

// Единая функция для отправки событий — безопасна даже если analytics = null
export function logEvent(eventName, params = {}) {
  if (analytics) {
    _logEvent(analytics, eventName, params);
  }
}